import { FC } from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material';

const Loader = styled(Box)({
  left: 0,
  top: 0,
  zIndex: 999999,
  height: '80vh',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
});

const PageLoader: FC = () => {
  return (
    <Loader>
      <CircularProgress />
    </Loader>
  );
};

export default PageLoader;
